import { Container } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import './index.css';

export const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about-page">
      <div className="about-header">
        <h1 className="about-title">{t('about.title')}</h1>
        <div className="section-divider" />
      </div>

      <Container maxWidth="md">
        <div className="about-body">
          <p className="about-text">
            <Trans i18nKey="about.intro" components={{ strong: <strong /> }} />
          </p>

          <div className="about-separator" />

          <p className="about-text">
            <Trans i18nKey="about.lab" components={{ strong: <strong /> }} />
          </p>

          <div className="about-separator" />

          <p className="about-text">
            <Trans
              i18nKey="about.approach"
              components={{ strong: <strong /> }}
            />
          </p>

          <div className="about-separator" />

          <p className="about-text about-closing">
            <Trans
              i18nKey="about.safeHands"
              components={{ strong: <strong /> }}
            />
          </p>
        </div>
      </Container>
    </div>
  );
};
